;(function () {
  'use strict'

  angular.module('common.services').factory('userFactory', [
    '$rootScope',
    '$http',
    '$filter',
    '$cookies',
    '$localStorage',
    'organizationFactory',
    function (
      $rootScope,
      $http,
      $filter,
      $cookies,
      $localStorage,
      organizationFactory
    ) {
      var AUTH_TOKEN = 'authUser'

      var list
      this.list = []
      this.findItemById = function (id) {
        var returnValue = {
          status: 0
        }
        var item = $filter('filter')(this.list, { id: id })
        if (item.length > 0) {
          returnValue.status = 1
          returnValue.item = item[0]
          returnValue.index = this.list.indexOf(returnValue.item)
        }
        return returnValue
      }
      this.addOrUpdateItem = function (item) {
        var itemData = this.findItemById(item.id)
        if (itemData.status == 1) {
          this.list[itemData.index] = item
        } else {
          this.list.push(item)
        }
      }
      this.deleteItemById = function (id) {
        var itemData = this.findItemById(id)
        if (itemData.status == 1) {
          var index = itemData.index
          this.list.splice(index, 1)
        }
      }

      this.setAuth = setAuth
      this.clearAuth = clearAuth
      this.login = login
      this.generateAuthToken = generateAuthToken
      this.getUserData = getUserData
      this.runAuthGuard = runAuthGuard
      this.saveUserConsentData = saveUserConsentData
      this.onUserLogin = onUserLogin

      function setAuth (token, organizationId) {
        var authUser = {
          token: token,
          organizationId: organizationId,
          domain: NEW_APP_DOMAIN
        }

        $cookies.putObject(AUTH_TOKEN, authUser, {
          expires: moment()
            .add(1, 'days')
            .toDate()
        })
      }

      function clearAuth () {
        $cookies.remove(AUTH_TOKEN)
      }

      function getUser (id) {
        return $http({
          method: 'GET',
          url: USER_BASEURL + '/user/' + id,
          data: {}
        })
      }

      async function getUserData () {
        return $http({
          method: 'GET',
          url: API_URL_V2 + '/me'
        })
      }

      function login (login_data) {
        return $http({
          method: 'POST',
          url: USER_BASEURL + '/login',
          data: login_data
        })
      }

      function getSettings () {
        return $http({
          method: 'GET',
          url: `${USER_BASEURL}/user/settings`
        })
      }

      function generateAuthToken (userToken) {
        return $http({
          method: 'GET',
          url: MEDIACORE_BASEURL + '/generate_authtoken'
        })
      }

      function saveUserConsentData (userId, userEmail) {
        var ua = navigator.userAgent

        var tem

        var M =
          ua.match(
            /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
          ) || []
        var userConsent = {}
        userConsent.browser = M[1]
        userConsent.userId = userId
        userConsent.email = userEmail
        // userConsent.username='ramya@krify.net';
        var UTCstring = new Date().toUTCString()
        userConsent.date = UTCstring
        // ~ console.log(moment(userConsent.date, 'YYYY-MM-DD'))
        // ~ console.log(new Date().toString('dd MMM yyyy'))
        // ~ console.log(userConsent)
        // ~ console.log($scope.ipaddress.ip)

        return $http({
          method: 'POST',
          url: USER_BASEURL + '/consent',
          data: userConsent
        }).then(
          function (response) {
            // ~ console.log(response)
          },
          function (response) {
            alert('Error occurred. Please try again.')
          }
        )
      }

      function runAuthGuard () {
        return new Promise(async (resolve, reject) => {
          try {
            if ($localStorage.isResellerSso) {
              $cookies.remove(AUTH_TOKEN)
              resolve()
              return
            } else {
              const authUser = $cookies.getObject(AUTH_TOKEN)

              if (
                authUser &&
                authUser.token &&
                authUser.token === $localStorage.userToken
              ) {
                resolve()
                return
              }

              /* if cookie data is missing */
              if (!authUser || !authUser.token) {
                resolve()
                return
              }

              $localStorage.userToken = authUser.token
            }

            const { data } = await getUserData()
            const { me, entity } = data.data

            const results = await Promise.all([getUser(me.id), getSettings()])

            let userDetails = results[0].data.user
            const settings = results[1].data.userSettings || {}

            userDetails = {
              is_reseller: entity === 'partner',
              super_admin: userDetails.role === 'super admin',
              userSettings: settings,
              ...userDetails
            }

            await onUserLogin(authUser.token, userDetails)

            resolve()
          } catch (e) {
            reject(e)
          }
        })
      }

      async function onUserLogin (token, userDetails) {
        return new Promise(async (resolve, reject) => {
          try {
            $localStorage.isResellerSso = false
            $localStorage.userToken = token
            $localStorage.userDetails = userDetails

            const { id, email } = userDetails

            saveUserConsentData(id, email)

            $localStorage.partnerData = userDetails.reseller
            $localStorage.currentUserOrganization = {
              id: $localStorage.userDetails.organizationId
            }
            $rootScope.currentUserOrganization = {
              id: $localStorage.userDetails.organizationId
            }
            $localStorage.currentUserOrganization =
              $rootScope.currentUserOrganization
            if (
              userDetails.userSettings.timeFormat ||
              userDetails.userSettings.mesaurement
            ) {
              $localStorage.measurementUnits =
                userDetails.userSettings.mesaurement
              $localStorage.timeFormat = userDetails.userSettings.timeFormat
            } else {
              $localStorage.measurementUnits = 1
              $localStorage.timeFormat = 2
            }

            const results = await Promise.all([
              generateAuthToken(token).then(
                function (response) {
                  if (response.data.status.code === 0) {
                    $localStorage.userMediaAccessToken = response.data.token
                  }
                },
                () => {}
              ),
              organizationFactory
                .getOrganization($localStorage.currentUserOrganization.id)
                .then(function (response) {
                  if (response.data.status.code == 0) {
                    $localStorage.userOrganization = response.data.organization
                  }
                })
            ])

            if (window.heap) {
              window.heap.identify(userDetails.email, 'email')
            }

            resolve()
          } catch (e) {
            reject(e)
          }
        })
      }

      return this
    }
  ])
})()
